import React, { useState, useEffect, useRef } from "react";
import "./ListedJobs.css";
import ApiService from "../Service/ApiService";
import Nav from "../Nav/Nav";
import JobVacancy from "../JobVacancy/JobVacancy";
import Footer from "../Footer/Footer";
import projectGalleryData from "../../data/projectgallery.json";

const ListedJobs = () => {
  const [project, setProject] = useState([]);

  useEffect(() => {
    if (projectGalleryData && projectGalleryData.length > 0) {
      const randomIndex = Math.floor(Math.random() * projectGalleryData.length);
      setProject(projectGalleryData[randomIndex]);
    }
  }, []);

  const [isAlbanian, setIsAlbanian] = useState(() => {
    const savedLanguage = localStorage.getItem("language");
    return savedLanguage !== null ? JSON.parse(savedLanguage) : true;
  });

  const toggleLanguage = () => {
    setIsAlbanian((prev) => {
      const newLanguage = !prev;
      localStorage.setItem("language", JSON.stringify(newLanguage));
      return newLanguage;
    });
  };

  return (
    <>
      <div className="listedjobs-container-up">
        <Nav isAlbanian={isAlbanian} toggleLanguage={toggleLanguage} />
        <div className="listedjobs-container">
          <img
            src={project.gallery_image_url}
            alt="listedjobs-photo"
            className="listedjobs-image"
          />
          <div className="overlay">
            <div className="vertical-line left"></div>
            <div className="vertical-line right"></div>
            <div className="hero-title">
              <h1 className="overlay-text">
                {"  "}
                <strong>
                  <span class="protest-font"></span>
                  <img
                    src="/underlined2-1.png"
                    alt="Underline decoration"
                    className="underline-image"
                  />
                </strong>{" "}
              </h1>
            </div>
            <div className="bottom-line"></div>
          </div>
        </div>
        <JobVacancy isAlbanian={isAlbanian} />
      </div>
      <Footer isAlbanian={isAlbanian} />
    </>
  );
};

export default ListedJobs;
